// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `


.header {
  display: flex;
  flex: 1 1;
  flex-direction: column;
  background: linear-gradient(135deg, #d5e2ee, #8dbc8a);
  

}



.matrix-logo {

  width: 10%;
  height: 70px;
    
  }
  

.header-top-navbar {

  display: flex;
  flex: 1 1;
  flex-direction: column;
  

}



.Main-section {


  display: 'flex';
  flex-direction: column;
  height: auto;
  background-color: white;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  border-radius: 0px;
  width: 100%; /* Set maximum width to prevent overflow */
  padding: 0; /* Add padding for better spacing */
  margin: 0;




}




.searchBar{

width: 50%;
height: 30px;
margin-top: 10%;
border-radius: 22px;
border: 2px solid rgb(107, 105, 105)

}


.text_search{
margin-top: 10%;
font-family: 'Montserrat regular';
font-size: 20px;
border-radius: 15px;
width: 40%;
padding: 10px 15px;
outline: none;
border: 2px solid rgb(174, 173, 173)
}



.search_section {

  display: flex;
  flex: 1 1;
  flex-direction: column;

  
  

}


.Matrix-container{

  display: inline-block;
  /*background: #FFFFFF;*/
  background: linear-gradient(135deg, #d5e2ee,#8dbc8a);
  margin-left : 5%;
  margin-bottom : 1%;
  width: 50%;
  border-radius: 22px;
  padding: 1rem;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}

.Matrix-element{

  margin-bottom : 1%;
  width: 90% ;
  border-radius: 0 4px 4px 4px;
  padding: 1rem;
  height: 55vh;
}


.btn-download{
  width: 100px;
  height: 30px;
  border-radius: 30px;
  cursor: pointer;
  background: linear-gradient(135deg, #d5e2ee,#8dbc8a);
  margin-top: 3%;
  }

 


   

   
    /* Ensuring the paragraph itself does not introduce unwanted spacing */
  .p-style {
        display: flex;
        
        margin: 0; /* Adjust or remove this as necessary for your design */
        margin-top : 2%;
    }
    

  .table-container {
    margin-left : 3%;
    margin-top : 1%;
    width: 100%;
    border-radius: 5px;
    overflow-x: auto;
    height: 100%;
    padding: 20px;
    
  }

  .table-container-comment {
    margin-left : 5%;
    margin-top : 1%;
    width: 100%;
    border-radius: 5px;
    overflow-x: auto;
    height: 30vh;
    padding: 20px;
    
  }
  
  .table {
    width: 100%;
    border-collapse: collapse;
  }
  
  .table th,
  .table td {
    padding: 8px;
    border: 1px solid #dddddd;
    text-align: left;
  }
 
  /* Alternating row colors */
  .table tbody tr:nth-child(even) {
    background-color: #f2f2f2;
  }
  
  /* Hover effect */
  .table tbody tr:hover {
    background-color: #dddddd;
  }


  .filter-table{
    margin-top : 2%;

  }
  



.tmatrix-modal-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
  }

  
  
  .tmatrix-modal-content {
    display: flex ;
    background-color: white;
    padding: 20px;
    border-radius: 5px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  }
  
  .button-close {
    margin-top: 1px;
  }

  /* Container for the button and dropdown to position them relative to each other */
.menu-container {
  position: relative;
  display: inline-block; /* Use inline-block for minimal impact on layout */
}

/* Adjusted styles for the dropdown menu */
.menu-list {
  position: absolute;
  top: 100%; /* Position the menu right below the button */
  left: 0;
  z-index: 1000; /* Ensure the dropdown appears above other content */
  list-style: none;
  padding: 0;
  margin: 0;
  border: 1px solid #ddd;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  width: 120px;
  background-color: white;
}
  

  .menu-button {
    background-color: #002155; /*#006400;  Dark blue */
    color: white; /* White text for contrast */
    border: none;
    padding: 10px 20px;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    font-size: 16px;
    margin: 4px 2px;
    cursor: pointer;
    border-radius: 5px; /* Optional: rounded corners */
    transition: background-color 0.3s ease; /* Smooth transition for hover effect */
  }
  
  .menu-button:hover {
    background-color: #0f5d15;
  }
  
 

  

 
  
  .horizontal-bar {
    margin: 4% auto;
    width: 84%;
    padding: 12px 20px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 12px;
    background-color: #f8f8f8;
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    z-index: 10;
  }
  
  .input-field {
    flex-grow: 1;
    min-width: 200px;
    padding: 8px 12px;
    border: 1px solid #ccc;
    border-radius: 5px;
    font-size: 14px;
    outline: none;
  }
  
  .btn-upload,
  .action-button {
    /*background-color: #b9a190;*/
    background-color: #4a5568;
    /* background-color: #e07a5f; /* Warm Coral */
    /* background-color: #2b6cb0; /* Steel Blue */
    color: #fff;
    border: none;
    padding: 8px 16px;
    font-size: 14px;
    border-radius: 5px;
    cursor: pointer;
    transition: background-color 0.3s ease;
    display: flex;
    align-items: center;
    gap: 6px;
    height: 40px;
  }
  
  .btn-upload:hover,
  .action-button:hover {
    /*background-color: #a48779;*/
    background-color: #2d3748;
    /* background-color: #c35c46; /* Darker Coral */
   /*  background-color: #2c5282; /* Deep Blue */
  }
  
  .select-file {
    font-size: 14px;
    cursor: pointer;
    margin-left: 4px;
    padding: 8px 0;
  }

  .input-menu {
    width: 200px;
    padding: 8px;
    margin: 5px;
    border: 1px solid #ccc;
    border-radius: 4px;
  }
  
  datalist {
    border: 1px solid #ccc;
    border-radius: 4px;
  }
  
  

  .main {
    grid-area: main;
    padding: 20px;
    background-color: #fff;
  }


  /* Pagination.css */
.pagination-container {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
}

.pagination-button {
  background-color: #b9a190;
  color: white;
  border: none;
  padding: 10px 20px;
  margin: 0 5px;
  cursor: pointer;
  border-radius: 4px;
  font-size: 16px;
}

.pagination-button:disabled {
  background-color: #cccccc;
  cursor: not-allowed;
}

.pagination-info {
  margin: 0 10px;
  font-size: 16px;
}

.pagination-summary {
  margin-top: 10px;
  font-size: 14px;
}


/* === Info Container === */
.info-container {
  background-color: #ffffff;
  padding: 24px;
  border-radius: 12px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  width: 360px;
  max-width: 90%;
  margin: 40px auto;
  font-family: 'Roboto', Arial, sans-serif;
  text-align: center;
  line-height: 1.6;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  word-wrap: break-word;
  overflow-wrap: break-word;
}

/* Hover effect */
.info-container:hover {
  transform: translateY(-4px);
  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.12);
}

/* === Heading === */
.info-container h2 {
  margin-bottom: 20px;
  font-size: 1.6rem;
  font-weight: 600;
  color: #1a202c;
  letter-spacing: 0.4px;
}

/* === Paragraphs === */
.info-container p {
  margin: 10px 0;
  font-size: 1rem;
  color: #4a5568;
  word-break: break-word;
  overflow-wrap: break-word;
  white-space: normal;
}

/* === Labels (e.g. “Shape:”) === */
.info-container p strong {
  color: #2d3748;
  font-weight: 500;
}

/* === Special class for long strings like T-matrix ID === */
.break-word {
  word-break: break-word;
  overflow-wrap: break-word;
  white-space: normal;
  font-family: monospace;
  font-size: 0.95rem;
  background-color: #f7fafc;
  padding: 6px 8px;
  border-radius: 4px;
  color: #2a4365;
}


.spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #ccc;
  border-top: 4px solid #000;
  border-radius: 50%;
  animation: spin 1s linear infinite;

  /* Center the spinner */
  display: block;
  margin: 0 auto;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}



@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}


.cards-container {
  display: grid;
  grid-template-columns:  repeat(4, 1fr); /* 4 element per row but i can still deploy the responsice columns using repeat(auto-fit, minmax(250px, 1fr))*/
  gap: 20px; /* Space between cards */
  grid-auto-rows: auto; /* Dynamically adjusts height based on content */
  padding: 20px;
  background-color: #ffffff; /* Subtle background color */
}

.card-container {
  background: #ffffff; /* Card background color */
  border: 1px solid #ddd; /* Light border for distinction */
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); /* Softer shadow */
  border-radius: 12px; /* More rounded corners */
  overflow: visible;
  transition: transform 0.2s, box-shadow 0.2s; /* Smooth hover effect */
}

.card-container:hover {
  transform: translateY(-5px); /* Slight lift effect on hover */
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15); /* Enhance shadow on hover */
}

.card-header {
  height: 180px; /* Taller header for better visuals */
  width: 100%;
  background-color: #e0e0e0; /* Fallback color if no image */
  background-size: cover;
  background-position: center;
}

.card-content {
  padding: 16px;
  text-align: left; /* Consistent alignment */
}

.card-content h3 {
  margin: 0;
  padding-bottom: 10px;
  font-size: 22px; /* Slightly smaller for balance */
  color: #333; /* Neutral text color */
  font-weight: bold;
}

.card-content p {
  margin: 8px 0; /* Add spacing between paragraphs */
  font-size: 14px;
  line-height: 1.5; /* Improve readability */
  color: #555; /* Muted text color */
}

.card-content .p-style {
  margin-top: 10px;
  display: flex;
  justify-content: space-around; /* Even spacing */
  align-items: center;
  padding: 10px 0;
}

.icon-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f0f2f5;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  transition: background-color 0.3s, transform 0.3s;
  position: relative;
  cursor: pointer;
}

.icon-wrapper:hover {
  background-color: #e0e7ff;
  transform: scale(1.1);
}



.Icon-show, .Icon-download, .Icon-note, .icon-clear {
  font-size: 24px;
  color: #007BFF;
  transition: color 0.2s;
}

.icon-wrapper:hover .Icon-show,
.icon-wrapper:hover .Icon-download,
.icon-wrapper:hover .icon-clear,
.icon-wrapper:hover .Icon-note {
  color: #0056b3;
}

/* Tooltip style */
.icon-wrapper::after {
  content: attr(data-tooltip);
  position: absolute;
  bottom: -30px;
  background-color: #333;
  color: #fff;
  font-size: 12px;
  padding: 4px 8px;
  border-radius: 4px;
  white-space: nowrap;
  opacity: 0;
  transform: translateY(10px);
  pointer-events: none;
  transition: opacity 0.3s, transform 0.3s;
}

.icon-wrapper:hover::after {
  opacity: 1;
  transform: translateY(0);
}


/* Media query for smaller screens */
@media (max-width: 768px) {
  .card-content h3 {
      font-size: 20px;
  }

  .card-content p {
      font-size: 13px;
  }

  .cards-container {
    grid-template-columns: repeat(2, 1fr); /* 2 cards per row for tablets */
}
}


@media (max-width: 480px) {
  .cards-container {
      grid-template-columns: 1fr; /* 1 card per row for small screens */
  }
}


/* Adjust for different screen sizes */
@media (max-width: 1200px) {
  .cards-container {
      grid-template-columns: repeat(3, 1fr); /* 3 cards per row for medium screens */
  }
}

.no-data {
  text-align: center;
  margin-top: 20px;
  font-size: 1.2rem;
  color: #888;
}


.copy-icon {
  margin-left: 10px;
  cursor: pointer;
  color: #4a5568;
  transition: color 0.2s ease;
  display: inline-flex;
  vertical-align: middle;
}

.copy-icon:hover {
  color: #2b6cb0;
}

.copy-confirm {
  margin-left: 8px;
  font-size: 0.85rem;
  color: #38a169; /* green */
  font-weight: 500;
  animation: fadeOut 1.5s ease forwards;
}

@keyframes fadeOut {
  0%   { opacity: 1; }
  80%  { opacity: 1; }
  100% { opacity: 0; }
}
`, "",{"version":3,"sources":["webpack://./src/Components/MainSection/MainSection.css"],"names":[],"mappings":";;;AAGA;EACE,aAAa;EACb,SAAO;EACP,sBAAsB;EACtB,qDAAqD;;;AAGvD;;;;AAIA;;EAEE,UAAU;EACV,YAAY;;EAEZ;;;AAGF;;EAEE,aAAa;EACb,SAAO;EACP,sBAAsB;;;AAGxB;;;;AAIA;;;EAGE,eAAe;EACf,sBAAsB;EACtB,YAAY;EACZ,uBAAuB;EACvB,4EAA4E;EAC5E,kBAAkB;EAClB,WAAW,EAAE,0CAA0C;EACvD,UAAU,EAAE,mCAAmC;EAC/C,SAAS;;;;;AAKX;;;;;AAKA;;AAEA,UAAU;AACV,YAAY;AACZ,eAAe;AACf,mBAAmB;AACnB;;AAEA;;;AAGA;AACA,eAAe;AACf,iCAAiC;AACjC,eAAe;AACf,mBAAmB;AACnB,UAAU;AACV,kBAAkB;AAClB,aAAa;AACb;AACA;;;;AAIA;;EAEE,aAAa;EACb,SAAO;EACP,sBAAsB;;;;;AAKxB;;;AAGA;;EAEE,qBAAqB;EACrB,uBAAuB;EACvB,oDAAoD;EACpD,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,mBAAmB;EACnB,aAAa;EACb,4EAA4E;AAC9E;;AAEA;;EAEE,kBAAkB;EAClB,WAAW;EACX,4BAA4B;EAC5B,aAAa;EACb,YAAY;AACd;;;AAGA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,oDAAoD;EACpD,cAAc;EACd;;;;;;;;IAQE,sEAAsE;EACxE;QACM,aAAa;;QAEb,SAAS,EAAE,uDAAuD;QAClE,eAAe;IACnB;;;EAGF;IACE,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,aAAa;;EAEf;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,aAAa;;EAEf;;EAEA;IACE,WAAW;IACX,yBAAyB;EAC3B;;EAEA;;IAEE,YAAY;IACZ,yBAAyB;IACzB,gBAAgB;EAClB;;EAEA,2BAA2B;EAC3B;IACE,yBAAyB;EAC3B;;EAEA,iBAAiB;EACjB;IACE,yBAAyB;EAC3B;;;EAGA;IACE,eAAe;;EAEjB;;;;;AAKF;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;;;;EAIA;IACE,cAAc;IACd,uBAAuB;IACvB,aAAa;IACb,kBAAkB;IAClB,wCAAwC;EAC1C;;EAEA;IACE,eAAe;EACjB;;EAEA,kFAAkF;AACpF;EACE,kBAAkB;EAClB,qBAAqB,EAAE,kDAAkD;AAC3E;;AAEA,0CAA0C;AAC1C;EACE,kBAAkB;EAClB,SAAS,EAAE,6CAA6C;EACxD,OAAO;EACP,aAAa,EAAE,oDAAoD;EACnE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,sBAAsB;EACtB,kBAAkB;EAClB,wCAAwC;EACxC,YAAY;EACZ,uBAAuB;AACzB;;;EAGE;IACE,yBAAyB,EAAE,uBAAuB;IAClD,YAAY,EAAE,4BAA4B;IAC1C,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,qBAAqB;IACrB,qBAAqB;IACrB,eAAe;IACf,eAAe;IACf,eAAe;IACf,kBAAkB,EAAE,8BAA8B;IAClD,sCAAsC,EAAE,uCAAuC;EACjF;;EAEA;IACE,yBAAyB;EAC3B;;;;;;;;EAQA;IACE,eAAe;IACf,UAAU;IACV,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,SAAS;IACT,yBAAyB;IACzB,yCAAyC;IACzC,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,aAAa;EACf;;EAEA;;IAEE,6BAA6B;IAC7B,yBAAyB;IACzB,6CAA6C;IAC7C,6CAA6C;IAC7C,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,sCAAsC;IACtC,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,YAAY;EACd;;EAEA;;IAEE,6BAA6B;IAC7B,yBAAyB;IACzB,+CAA+C;GAChD,6CAA6C;EAC9C;;EAEA;IACE,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,WAAW;IACX,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;EACpB;;;;EAIA;IACE,eAAe;IACf,aAAa;IACb,sBAAsB;EACxB;;;EAGA,mBAAmB;AACrB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;;AAGA,2BAA2B;AAC3B;EACE,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,yCAAyC;EACzC,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;EAChB,qDAAqD;EACrD,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA,iBAAiB;AACjB;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA,uBAAuB;AACvB;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,mCAAmC;AACnC;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,4DAA4D;AAC5D;EACE,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;;AAGA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,0BAA0B;EAC1B,kBAAkB;EAClB,kCAAkC;;EAElC,uBAAuB;EACvB,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;;;;AAIA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;;AAGA;EACE,aAAa;EACb,sCAAsC,EAAE,8GAA8G;EACtJ,SAAS,EAAE,wBAAwB;EACnC,oBAAoB,EAAE,gDAAgD;EACtE,aAAa;EACb,yBAAyB,EAAE,4BAA4B;AACzD;;AAEA;EACE,mBAAmB,EAAE,0BAA0B;EAC/C,sBAAsB,EAAE,iCAAiC;EACzD,wCAAwC,EAAE,kBAAkB;EAC5D,mBAAmB,EAAE,yBAAyB;EAC9C,iBAAiB;EACjB,2CAA2C,EAAE,wBAAwB;AACvE;;AAEA;EACE,2BAA2B,EAAE,gCAAgC;EAC7D,0CAA0C,EAAE,4BAA4B;AAC1E;;AAEA;EACE,aAAa,EAAE,qCAAqC;EACpD,WAAW;EACX,yBAAyB,EAAE,+BAA+B;EAC1D,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,gBAAgB,EAAE,yBAAyB;AAC7C;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,eAAe,EAAE,iCAAiC;EAClD,WAAW,EAAE,uBAAuB;EACpC,iBAAiB;AACnB;;AAEA;EACE,aAAa,EAAE,mCAAmC;EAClD,eAAe;EACf,gBAAgB,EAAE,wBAAwB;EAC1C,WAAW,EAAE,qBAAqB;AACpC;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,6BAA6B,EAAE,iBAAiB;EAChD,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,iDAAiD;EACjD,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;;;AAIA;EACE,eAAe;EACf,cAAc;EACd,sBAAsB;AACxB;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,UAAU;EACV,2BAA2B;EAC3B,oBAAoB;EACpB,wCAAwC;AAC1C;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;;AAGA,oCAAoC;AACpC;EACE;MACI,eAAe;EACnB;;EAEA;MACI,eAAe;EACnB;;EAEA;IACE,qCAAqC,EAAE,gCAAgC;AAC3E;AACA;;;AAGA;EACE;MACI,0BAA0B,EAAE,qCAAqC;EACrE;AACF;;;AAGA,sCAAsC;AACtC;EACE;MACI,qCAAqC,EAAE,uCAAuC;EAClF;AACF;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb;;;AAGA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,2BAA2B;EAC3B,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc,EAAE,UAAU;EAC1B,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,OAAO,UAAU,EAAE;EACnB,OAAO,UAAU,EAAE;AACrB","sourcesContent":["\n\n\n.header {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  background: linear-gradient(135deg, #d5e2ee, #8dbc8a);\n  \n\n}\n\n\n\n.matrix-logo {\n\n  width: 10%;\n  height: 70px;\n    \n  }\n  \n\n.header-top-navbar {\n\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  \n\n}\n\n\n\n.Main-section {\n\n\n  display: 'flex';\n  flex-direction: column;\n  height: auto;\n  background-color: white;\n  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);\n  border-radius: 0px;\n  width: 100%; /* Set maximum width to prevent overflow */\n  padding: 0; /* Add padding for better spacing */\n  margin: 0;\n\n\n\n\n}\n\n\n\n\n.searchBar{\n\nwidth: 50%;\nheight: 30px;\nmargin-top: 10%;\nborder-radius: 22px;\nborder: 2px solid rgb(107, 105, 105)\n\n}\n\n\n.text_search{\nmargin-top: 10%;\nfont-family: 'Montserrat regular';\nfont-size: 20px;\nborder-radius: 15px;\nwidth: 40%;\npadding: 10px 15px;\noutline: none;\nborder: 2px solid rgb(174, 173, 173)\n}\n\n\n\n.search_section {\n\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n\n  \n  \n\n}\n\n\n.Matrix-container{\n\n  display: inline-block;\n  /*background: #FFFFFF;*/\n  background: linear-gradient(135deg, #d5e2ee,#8dbc8a);\n  margin-left : 5%;\n  margin-bottom : 1%;\n  width: 50%;\n  border-radius: 22px;\n  padding: 1rem;\n  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);\n}\n\n.Matrix-element{\n\n  margin-bottom : 1%;\n  width: 90% ;\n  border-radius: 0 4px 4px 4px;\n  padding: 1rem;\n  height: 55vh;\n}\n\n\n.btn-download{\n  width: 100px;\n  height: 30px;\n  border-radius: 30px;\n  cursor: pointer;\n  background: linear-gradient(135deg, #d5e2ee,#8dbc8a);\n  margin-top: 3%;\n  }\n\n \n\n\n   \n\n   \n    /* Ensuring the paragraph itself does not introduce unwanted spacing */\n  .p-style {\n        display: flex;\n        \n        margin: 0; /* Adjust or remove this as necessary for your design */\n        margin-top : 2%;\n    }\n    \n\n  .table-container {\n    margin-left : 3%;\n    margin-top : 1%;\n    width: 100%;\n    border-radius: 5px;\n    overflow-x: auto;\n    height: 100%;\n    padding: 20px;\n    \n  }\n\n  .table-container-comment {\n    margin-left : 5%;\n    margin-top : 1%;\n    width: 100%;\n    border-radius: 5px;\n    overflow-x: auto;\n    height: 30vh;\n    padding: 20px;\n    \n  }\n  \n  .table {\n    width: 100%;\n    border-collapse: collapse;\n  }\n  \n  .table th,\n  .table td {\n    padding: 8px;\n    border: 1px solid #dddddd;\n    text-align: left;\n  }\n \n  /* Alternating row colors */\n  .table tbody tr:nth-child(even) {\n    background-color: #f2f2f2;\n  }\n  \n  /* Hover effect */\n  .table tbody tr:hover {\n    background-color: #dddddd;\n  }\n\n\n  .filter-table{\n    margin-top : 2%;\n\n  }\n  \n\n\n\n.tmatrix-modal-backdrop {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.5);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n\n  \n  \n  .tmatrix-modal-content {\n    display: flex ;\n    background-color: white;\n    padding: 20px;\n    border-radius: 5px;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  }\n  \n  .button-close {\n    margin-top: 1px;\n  }\n\n  /* Container for the button and dropdown to position them relative to each other */\n.menu-container {\n  position: relative;\n  display: inline-block; /* Use inline-block for minimal impact on layout */\n}\n\n/* Adjusted styles for the dropdown menu */\n.menu-list {\n  position: absolute;\n  top: 100%; /* Position the menu right below the button */\n  left: 0;\n  z-index: 1000; /* Ensure the dropdown appears above other content */\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  width: 120px;\n  background-color: white;\n}\n  \n\n  .menu-button {\n    background-color: #002155; /*#006400;  Dark blue */\n    color: white; /* White text for contrast */\n    border: none;\n    padding: 10px 20px;\n    text-align: center;\n    text-decoration: none;\n    display: inline-block;\n    font-size: 16px;\n    margin: 4px 2px;\n    cursor: pointer;\n    border-radius: 5px; /* Optional: rounded corners */\n    transition: background-color 0.3s ease; /* Smooth transition for hover effect */\n  }\n  \n  .menu-button:hover {\n    background-color: #0f5d15;\n  }\n  \n \n\n  \n\n \n  \n  .horizontal-bar {\n    margin: 4% auto;\n    width: 84%;\n    padding: 12px 20px;\n    display: flex;\n    align-items: center;\n    flex-wrap: wrap;\n    gap: 12px;\n    background-color: #f8f8f8;\n    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);\n    border-radius: 8px;\n    z-index: 10;\n  }\n  \n  .input-field {\n    flex-grow: 1;\n    min-width: 200px;\n    padding: 8px 12px;\n    border: 1px solid #ccc;\n    border-radius: 5px;\n    font-size: 14px;\n    outline: none;\n  }\n  \n  .btn-upload,\n  .action-button {\n    /*background-color: #b9a190;*/\n    background-color: #4a5568;\n    /* background-color: #e07a5f; /* Warm Coral */\n    /* background-color: #2b6cb0; /* Steel Blue */\n    color: #fff;\n    border: none;\n    padding: 8px 16px;\n    font-size: 14px;\n    border-radius: 5px;\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    height: 40px;\n  }\n  \n  .btn-upload:hover,\n  .action-button:hover {\n    /*background-color: #a48779;*/\n    background-color: #2d3748;\n    /* background-color: #c35c46; /* Darker Coral */\n   /*  background-color: #2c5282; /* Deep Blue */\n  }\n  \n  .select-file {\n    font-size: 14px;\n    cursor: pointer;\n    margin-left: 4px;\n    padding: 8px 0;\n  }\n\n  .input-menu {\n    width: 200px;\n    padding: 8px;\n    margin: 5px;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n  }\n  \n  datalist {\n    border: 1px solid #ccc;\n    border-radius: 4px;\n  }\n  \n  \n\n  .main {\n    grid-area: main;\n    padding: 20px;\n    background-color: #fff;\n  }\n\n\n  /* Pagination.css */\n.pagination-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: 20px;\n}\n\n.pagination-button {\n  background-color: #b9a190;\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  margin: 0 5px;\n  cursor: pointer;\n  border-radius: 4px;\n  font-size: 16px;\n}\n\n.pagination-button:disabled {\n  background-color: #cccccc;\n  cursor: not-allowed;\n}\n\n.pagination-info {\n  margin: 0 10px;\n  font-size: 16px;\n}\n\n.pagination-summary {\n  margin-top: 10px;\n  font-size: 14px;\n}\n\n\n/* === Info Container === */\n.info-container {\n  background-color: #ffffff;\n  padding: 24px;\n  border-radius: 12px;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);\n  width: 360px;\n  max-width: 90%;\n  margin: 40px auto;\n  font-family: 'Roboto', Arial, sans-serif;\n  text-align: center;\n  line-height: 1.6;\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n}\n\n/* Hover effect */\n.info-container:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.12);\n}\n\n/* === Heading === */\n.info-container h2 {\n  margin-bottom: 20px;\n  font-size: 1.6rem;\n  font-weight: 600;\n  color: #1a202c;\n  letter-spacing: 0.4px;\n}\n\n/* === Paragraphs === */\n.info-container p {\n  margin: 10px 0;\n  font-size: 1rem;\n  color: #4a5568;\n  word-break: break-word;\n  overflow-wrap: break-word;\n  white-space: normal;\n}\n\n/* === Labels (e.g. “Shape:”) === */\n.info-container p strong {\n  color: #2d3748;\n  font-weight: 500;\n}\n\n/* === Special class for long strings like T-matrix ID === */\n.break-word {\n  word-break: break-word;\n  overflow-wrap: break-word;\n  white-space: normal;\n  font-family: monospace;\n  font-size: 0.95rem;\n  background-color: #f7fafc;\n  padding: 6px 8px;\n  border-radius: 4px;\n  color: #2a4365;\n}\n\n\n.spinner {\n  width: 40px;\n  height: 40px;\n  border: 4px solid #ccc;\n  border-top: 4px solid #000;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n\n  /* Center the spinner */\n  display: block;\n  margin: 0 auto;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n\n\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n\n.cards-container {\n  display: grid;\n  grid-template-columns:  repeat(4, 1fr); /* 4 element per row but i can still deploy the responsice columns using repeat(auto-fit, minmax(250px, 1fr))*/\n  gap: 20px; /* Space between cards */\n  grid-auto-rows: auto; /* Dynamically adjusts height based on content */\n  padding: 20px;\n  background-color: #ffffff; /* Subtle background color */\n}\n\n.card-container {\n  background: #ffffff; /* Card background color */\n  border: 1px solid #ddd; /* Light border for distinction */\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); /* Softer shadow */\n  border-radius: 12px; /* More rounded corners */\n  overflow: visible;\n  transition: transform 0.2s, box-shadow 0.2s; /* Smooth hover effect */\n}\n\n.card-container:hover {\n  transform: translateY(-5px); /* Slight lift effect on hover */\n  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15); /* Enhance shadow on hover */\n}\n\n.card-header {\n  height: 180px; /* Taller header for better visuals */\n  width: 100%;\n  background-color: #e0e0e0; /* Fallback color if no image */\n  background-size: cover;\n  background-position: center;\n}\n\n.card-content {\n  padding: 16px;\n  text-align: left; /* Consistent alignment */\n}\n\n.card-content h3 {\n  margin: 0;\n  padding-bottom: 10px;\n  font-size: 22px; /* Slightly smaller for balance */\n  color: #333; /* Neutral text color */\n  font-weight: bold;\n}\n\n.card-content p {\n  margin: 8px 0; /* Add spacing between paragraphs */\n  font-size: 14px;\n  line-height: 1.5; /* Improve readability */\n  color: #555; /* Muted text color */\n}\n\n.card-content .p-style {\n  margin-top: 10px;\n  display: flex;\n  justify-content: space-around; /* Even spacing */\n  align-items: center;\n  padding: 10px 0;\n}\n\n.icon-wrapper {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: #f0f2f5;\n  border-radius: 50%;\n  width: 50px;\n  height: 50px;\n  transition: background-color 0.3s, transform 0.3s;\n  position: relative;\n  cursor: pointer;\n}\n\n.icon-wrapper:hover {\n  background-color: #e0e7ff;\n  transform: scale(1.1);\n}\n\n\n\n.Icon-show, .Icon-download, .Icon-note, .icon-clear {\n  font-size: 24px;\n  color: #007BFF;\n  transition: color 0.2s;\n}\n\n.icon-wrapper:hover .Icon-show,\n.icon-wrapper:hover .Icon-download,\n.icon-wrapper:hover .icon-clear,\n.icon-wrapper:hover .Icon-note {\n  color: #0056b3;\n}\n\n/* Tooltip style */\n.icon-wrapper::after {\n  content: attr(data-tooltip);\n  position: absolute;\n  bottom: -30px;\n  background-color: #333;\n  color: #fff;\n  font-size: 12px;\n  padding: 4px 8px;\n  border-radius: 4px;\n  white-space: nowrap;\n  opacity: 0;\n  transform: translateY(10px);\n  pointer-events: none;\n  transition: opacity 0.3s, transform 0.3s;\n}\n\n.icon-wrapper:hover::after {\n  opacity: 1;\n  transform: translateY(0);\n}\n\n\n/* Media query for smaller screens */\n@media (max-width: 768px) {\n  .card-content h3 {\n      font-size: 20px;\n  }\n\n  .card-content p {\n      font-size: 13px;\n  }\n\n  .cards-container {\n    grid-template-columns: repeat(2, 1fr); /* 2 cards per row for tablets */\n}\n}\n\n\n@media (max-width: 480px) {\n  .cards-container {\n      grid-template-columns: 1fr; /* 1 card per row for small screens */\n  }\n}\n\n\n/* Adjust for different screen sizes */\n@media (max-width: 1200px) {\n  .cards-container {\n      grid-template-columns: repeat(3, 1fr); /* 3 cards per row for medium screens */\n  }\n}\n\n.no-data {\n  text-align: center;\n  margin-top: 20px;\n  font-size: 1.2rem;\n  color: #888;\n}\n\n\n.copy-icon {\n  margin-left: 10px;\n  cursor: pointer;\n  color: #4a5568;\n  transition: color 0.2s ease;\n  display: inline-flex;\n  vertical-align: middle;\n}\n\n.copy-icon:hover {\n  color: #2b6cb0;\n}\n\n.copy-confirm {\n  margin-left: 8px;\n  font-size: 0.85rem;\n  color: #38a169; /* green */\n  font-weight: 500;\n  animation: fadeOut 1.5s ease forwards;\n}\n\n@keyframes fadeOut {\n  0%   { opacity: 1; }\n  80%  { opacity: 1; }\n  100% { opacity: 0; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
